// Import Types
import type { TFunction } from 'react-i18next';
import type { StepInitialConfig, StepWithStatusesAndActions } from './types';
// Import Constants
import l from 'constants/localizationLabels';
import { isEmpty } from 'lodash';

export const getStepsInitialConfigs = (steps: StepInitialConfig[], t: TFunction): StepWithStatusesAndActions[] => {
    return steps.map((step) => ({
        ...step,
        errorMessage: t(l.PleaseCompleteAllRequiredFields),
        isMounted: false,
        isValid: step.noValidate || null,
        isValidating: false,
        isLoading: false,
    }));
};

export const getStepsInitialValues = (steps: StepInitialConfig[]) =>
    steps.reduce((acc, { id, initialValues, defaultValues }) => {
        acc[id] = isEmpty(initialValues) ? (defaultValues ?? {}) : initialValues;
        return acc;
    }, {});
